<!-- Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved. -->
<ng-container *ngIf="!hasError">
  <ng-container *ngIf="!isLoading; else loading">
    <div class="layout">
      <aside>
        <!-- SV Pie Chart -->
        <app-hce-sv-pie-chart
          [chrOpts]="chrOpts"
          [pieChartData]="pieChartData"
        ></app-hce-sv-pie-chart>
      </aside>
      <main class="right">
        <!-- Bar Chart -->  
        <div class="charts-row">
          <!-- Deletions / Insertions Chart -->
          <div echarts [options]="inDelOpt" class="bar-chart"></div>
          <!-- Inversions Chart -->
          <div echarts [options]="invOpt" class="bar-chart"></div>
        </div>
        <!-- Chromosome List -->
        <div><p class="title">Chromosome</p></div>
        <div>
          <app-hce-stats-table
            [columnTitles]="chromosomeDisplayedColumnLabels"
            [columnKeys]="chromosomeDisplayedColumns"
            [data]="chromosomeListData"
            (cellFilterRequest)="onCellFilterRequest($event)"
          ></app-hce-stats-table>
        </div>
      </main>
    </div>
  </ng-container>

  <ng-template #loading>
    <div class="loader" aria-live="polite" aria-busy="true">
      <mat-spinner></mat-spinner>
    </div>
  </ng-template>
</ng-container>
